import src from "IMAGE";
export default { src, width: 1024, height: 221, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANUlEQVR42i3GoQ0AIAxFwb8HEgyWKZAoBIYwAWEa1u1rUnHJSdLGREdDQY1n6CNh4GLh4PkNiS8EyTYFWfcAAAAASUVORK5CYII="};
